import styled from "styled-components"

const ExerciseRowStyle = styled.div`
    padding: 20px 0;
    text-align: justify;
`

export default ExerciseRowStyle